import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Badge from 'components/badge';
import BadgeShow from 'components/badge_show';
import { CommunityBadgeIcon, PluralIcon, BrainIcon, TriviamasterIcon, DerDieDasIcon, MagnifyWordsIcon, BookIcon, ShakespeareIcon, MicrophoneBadgeIcon, CardsIcon, ClockfaceIcon } from '@seedlang/icons';
import { BadgeCollectionWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const EmptyBadges = styled.div`
  padding: 0 20px 20px 20px;
  font-weight: bold;
`;

const ICONS = {
  storyteller: ShakespeareIcon,
  interviewMe: MicrophoneBadgeIcon,
  deckmaster: CardsIcon,
  backInTime: ClockfaceIcon,
  storymaster: BookIcon,
  gendermaster: DerDieDasIcon,
  vocabmaster: MagnifyWordsIcon,
  brainiac: BrainIcon,
  triviamaster: TriviamasterIcon,
  pluralmaster: PluralIcon,
  community: CommunityBadgeIcon,
};

@observer
class BadgeCollection extends React.Component {
  @observable selectedBadge = null;

  onPressBadge = (badge) => {
    this.selectedBadge = {
      name: badge.name,
      description: badge.description,
      interpolationString: badge.interpolationString,
      current: badge.current || 0,
      levels: badge.levels,
      badgeSlug: badge.slug,
      user: this.props.user,
    };
  }

  render() {
    return (
      <Wrapper>
        {
          this.selectedBadge &&
            <BadgeShow
              badge={this.selectedBadge}
              onCloseModal={() => this.selectedBadge = null}
            />
        }
        {
          this.props.emptyBadges() &&
            <EmptyBadges>
              No badges have been earned yet.
            </EmptyBadges>
        }
        {
          this.props.filteredBadges.map(badge => {
            if (!this.props.hideLevel0 || badge.current >= badge.levels[0]) {
              return (
                <Badge
                  alignment={this.props.alignment}
                  width={this.props.width}
                  wrapperWidth={this.props.wrapperWidth}
                  wrapperHeight={this.props.wrapperHeight}
                  margin={this.props.margin}
                  badgeWidth={this.props.badgeWidth}
                  showProgress={this.props.showProgress}
                  key={badge.name}
                  onClick={() => this.onPressBadge(badge)}
                  name={badge.name}
                  description={badge.description}
                  current={badge.current || 0}
                  levels={badge.levels}
                  icon={React.createElement(ICONS[badge.slug])}
                  fontSize={this.props.fontSize}
                  textMarginTop={this.props.textMarginTop}
                  textMarginBottom={this.props.textMarginBottom}
                  bottom={this.props.bottom}
                  right={this.props.right}
                />
              );
            } else {
              return null;
            }
          })
        }
      </Wrapper>
    );
  }
}

export default BadgeCollectionWrapper(BadgeCollection);
